import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BaseButton } from 'iebt-zing-storybook'
import { Col } from 'react-bootstrap'

import { hasTextMatch } from 'sharedKernel/handlers'
import { trans } from 'sharedKernel/i18n'
import { IEvaluator } from './contracts'
import { SolutionContent, TitleContainer } from './styles'
import { HubTable } from 'components/HubDefaultTable'
import { CenterContent } from '../../../solutions/table/style'
import { AnimatedSortButtons } from 'components/HubDefaultTable/OrderByButton'
import { sortSolutions, sortRows } from './behavior'

export interface HubCompanyEvaluatorsChallengeTableProps {
  evaluators: Evaluators
  searchTerm: string
  showEditModal: (evaluator: any, solutionList: string[]) => void
}

interface Evaluators {
  rows: any[]
}

export interface SortTable {
  evaluatorNameAsc: boolean
}

export const NO_CONTENT_EVALUATORS_MESSAGE = 'Ainda não há avaliadores para atribuição'

export const HubCompanyEvaluatorsAssignTable = ({ evaluators, searchTerm, showEditModal }: HubCompanyEvaluatorsChallengeTableProps): JSX.Element => {
  const [sortTable, setSortTable] = useState<SortTable>({ evaluatorNameAsc: false })
  const labels = {
    evaluator: trans('Avaliador'),
    solution: trans('Solução'),
    actions: trans('Ações'),
    noEvaluators: trans(NO_CONTENT_EVALUATORS_MESSAGE)
  }

  const headerSize = ['46%', '44%', '10%']

  const tableHeader = (): any => {
    return [
      getCenteredContent(buildHeaderSolutionTitle()),
      labels.solution,
      labels.actions
    ]
  }

  const buildHeaderSolutionTitle = (): JSX.Element => {
    return (
      <>
        {labels.evaluator}
        <div className='ml-1'>
          <AnimatedSortButtons orderByAsc={sortTable.evaluatorNameAsc}
            onClick={() => {
              setSortTable({ ...sortTable, evaluatorNameAsc: !sortTable.evaluatorNameAsc })
            }} />
        </div>
      </>
    )
  }

  const getCenteredContent = (content: any): any => {
    return (
      <CenterContent>
        {content}
      </CenterContent>
    )
  }

  const buildEvaluatorRows = (): any[] => {
    // Filter evaluators first, then build rows
    const filteredEvaluators = evaluators.rows.filter((evaluator: IEvaluator) => {
      const solutionTitles = evaluator.resolvers
        .flatMap(resolver => resolver.solutions.map(s => s.title))
        .join(' ')
      return hasTextMatch(evaluator.name, searchTerm) || hasTextMatch(solutionTitles, searchTerm)
    })

    const rows = filteredEvaluators.map((evaluator: IEvaluator) => {
      return buildEvaluatorColumns(evaluator)
    })

    return sortRows(rows, sortTable.evaluatorNameAsc)
  }

  const buildEvaluatorColumns = (evaluator: IEvaluator): any[] => {
    const evaluatorColumns: any = []
    const solutionList: string[] = []
    let solutionCount = 0

    evaluatorColumns.push(getEvaluatorName(evaluator))

    evaluator.resolvers.forEach((resolver) => {
      resolver.solutions.forEach((solution) => {
        solutionCount++
        solutionList.push(solution.id)
      })
    })

    evaluatorColumns.push(getSolutionColumn(solutionCount))
    evaluatorColumns.push(getActionIcons(evaluator, solutionList))

    return evaluatorColumns
  }

  const getEvaluatorName = (evaluator: IEvaluator): JSX.Element => {
    return (
      <TitleContainer>{evaluator.name}</TitleContainer>
    )
  }

  const getSolutionColumn = (count: number): JSX.Element => {
    const solutionText = count === 1 ? 'solução' : 'soluções'
    return (
      <SolutionContent>{count} {solutionText}</SolutionContent>
    )
  }

  const getActionIcons = (evaluator: IEvaluator, solutionList: string[]): JSX.Element => {
    return (
      <Col className="d-flex align-items-center justify-content-start gap-2">
        <BaseButton
          btnContent={<FontAwesomeIcon icon={['fas', 'pen']} />}
          variant="primary-invert"
          size="icon"
          onClick={() => { showEditModal(evaluator, solutionList) }}
        />
        {/* MANTER BOTÃO OCULTO POR ENQUANTO
        <BaseButton
          btnContent={<FontAwesomeIcon icon={['fas', 'trash']} />}
          variant="primary-invert"
          size="icon"
          onClick={() => {
            // A fazer
          }}
        /> */}
      </Col>
    )
  }

  return (
    <>
      {
        evaluators === null || evaluators === undefined || evaluators.rows.length === 0
          ? <div className="d-flex justify-content-center">{labels.noEvaluators}</div>
          : <HubTable
            header={tableHeader()}
            rows={buildEvaluatorRows()}
            headerSize={headerSize} />
      }
    </>
  )
}
